import type { Fraction } from './fractionType';
import { approximateFractionValue, simplifyFraction } from './integerMath';

export const millisecondToSecond = (milliSeconds: number) => {
  return milliSeconds / 1000;
};

export function formatHmsmTime(totalSecs: number) {
  let sign = '';
  if (totalSecs < 0) {
    totalSecs = -totalSecs;
    sign = '-';
  }
  const totalMins = Math.floor(totalSecs / 60);
  const secs = totalSecs - totalMins * 60;
  const totalHours = Math.floor(totalMins / 60);
  const mins = totalMins - totalHours * 60;
  return sign + (totalHours ? totalHours + 'h' : '') + (totalMins ? mins + 'm' : '') + secs.toFixed(3) + 's';
}

/**
 * Make string from duration expressed as fraction, suitable for diagnostic
 * messages.
 */
export function formatDurationFraction(frac: Fraction) {
  const simple = simplifyFraction(frac);
  return simple.numerator + (simple.denominator == 1 ? '' : '/' + simple.denominator) + ' (' + formatHmsmTime(approximateFractionValue(frac)) + ')';
}
